import { createAction } from 'redux-act';

//****ONBOARDING STEPS*****
// get onboarding steps action
const getAllOnboardingDetailsRequest = createAction('GET_ONBOARDING_DETAILS_REQUEST', data => data);
const getAllOnboardingDetailsSuccess = createAction('GET_ONBOARDING_DETAILS_SUCCESS', data => data);
const getAllOnboardingDetailsError = createAction('GET_ONBOARDING_DETAILS_ERROR');

//****EMPLOYEE DOCUMENTS*****
// get employee documents steps action
const getAllEmpDocsRequest = createAction('GET_EMPLOYEE_DOCUMENTS_REQUEST', data => data);
const getAllEmpDocsSuccess = createAction('GET_EMPLOYEE_DOCUMENTS_SUCCESS', data => data);
const getAllEmpDocsError = createAction('GET_EMPLOYEE_DOCUMENTS_ERROR');

//****PERSONAL DETAILS*****
// add personal details action
const addPersonalDetailsRequest = createAction('ADD_PERSONAL_DETAILS_REQUEST', data => data);
const addPersonalDetailsSuccess = createAction('ADD_PERSONAL_DETAILS_SUCCESS', data => data);
const addPersonalDetailsError = createAction('ADD_PERSONAL_DETAILS_ERROR');

// get personal details action
const getAllPersonalDetailsRequest = createAction('GET_ALL_PERSONAL_DETAILS_REQUEST', data => data);
const getAllPersonalDetailsSuccess = createAction('GET_ALL_PERSONAL_DETAILS_SUCCESS', data => data);
const getAllPersonalDetailsError = createAction('GET_ALL_PERSONAL_DETAILS_ERROR');

// update personal details action
const updatePersonalDetailsRequest = createAction('UPDATE_PERSONAL_DETAILS_REQUEST', data => data);
const updatePersonalDetailsSuccess = createAction('UPDATE_PERSONAL_DETAILS_SUCCESS', data => data);
const updatePersonalDetailsError = createAction('UPDATE_PERSONAL_DETAILS_ERROR');

// clear existing personal details action
const handleClearPersonalDetails = createAction('HANDLE_CLEAR_PERSONAL_DETAILS', data => data);

//****FAMILY DETAILS*****
// add family details action
const addFamilyDetailsRequest = createAction('ADD_FAMILY_DETAILS_REQUEST', data => data);
const addFamilyDetailsSuccess = createAction('ADD_FAMILY_DETAILS_SUCCESS', data => data);
const addFamilyDetailsError = createAction('ADD_FAMILY_DETAILS_ERROR');

// get family details action
const getAllFamilyDetailsRequest = createAction('GET_ALL_FAMILY_DETAILS_REQUEST', data => data);
const getAllFamilyDetailsSuccess = createAction('GET_ALL_FAMILY_DETAILS_SUCCESS', data => data);
const getAllFamilyDetailsError = createAction('GET_ALL_FAMILY_DETAILS_ERROR');

// update family details action
const updateFamilyDetailsRequest = createAction('UPDATE_FAMILY_DETAILS_REQUEST', data => data);
const updateFamilyDetailsSuccess = createAction('UPDATE_FAMILY_DETAILS_SUCCESS', data => data);
const updateFamilyDetailsError = createAction('UPDATE_FAMILY_DETAILS_ERROR');

// clear existing family details action
const handleClearFamilyDetails = createAction('HANDLE_CLEAR_FAMILY_DETAILS', data => data);

//****EDUCATION DETAILS*****
// add Education Detail action
const addEducationDetailsRequest = createAction('ADD_EDUCATION_DETAILS_REQUEST', data => data);
const addEducationDetailsSuccess = createAction('ADD_EDUCATION_DETAILS_SUCCESS', data => data);
const addEducationDetailsError = createAction('ADD_EDUCATION_DETAILS_ERROR');

// get Education details action
const getEducationDetailsRequest = createAction('GET_EDUCATION_DETAILS_REQUEST', data => data);
const getEducationDetailsSuccess = createAction('GET_EDUCATION_DETAILS_SUCCESS', data => data);
const getEducationDetailsError = createAction('GET_EDUCATION_DETAILS_ERROR');

// update Education details action
const updateEducationDetailsRequest = createAction('UPDATE_EDUCTION_DETAILS_REQUEST', data => data);
const updateEducationDetailsSuccess = createAction('UPDATE_EDUCTION_DETAILS_SUCCESS', data => data);
const updateEducationDetailsError = createAction('UPDATE_EDUCTION_DETAILS_ERROR');

// clear existing Education details action
const handleClearEducationDetails = createAction('HANDLE_CLEAR_EDUCATION_DETAILS', data => data);

//****BANK DETAILS*****
// add Bank details action
const addBankDetailsRequest = createAction('ADD_BANK_DETAILS_REQUEST', data => data);
const addBankDetailsSuccess = createAction('ADD_BANK_DETAILS_SUCCESS', data => data);
const addBankDetailsError = createAction('ADD_BANK_DETAILS_ERROR');

// get Bank details action
const getAllBankDetailsRequest = createAction('GET_ALL_BANK_DETAILS_REQUEST', data => data);
const getAllBankDetailsSuccess = createAction('GET_ALL_BANK_DETAILS_SUCCESS', data => data);
const getAllBankDetailsError = createAction('GET_ALL_BANK_DETAILS_ERROR');

// update Bank details action
const updateBankDetailsRequest = createAction('UPDATE_BANK_DETAILS_REQUEST', data => data);
const updateBankDetailsSuccess = createAction('UPDATE_BANK_DETAILS_SUCCESS', data => data);
const updateBankDetailsError = createAction('UPDATE_BANK_DETAILS_ERROR');

// clear existing Bank details action
const handleClearBankDetails = createAction('HANDLE_CLEAR_BANK_DETAILS', data => data);

//****SOCIAL DETAILS*****
// add social details action
const addSocialDetailsRequest = createAction('ADD_SOCIAL_DETAILS_REQUEST', data => data);
const addSocialDetailsSuccess = createAction('ADD_SOCIAL_DETAILS_SUCCESS', data => data);
const addSocialDetailsError = createAction('ADD_SOCIAL_DETAILS_ERROR');

// get social details action
const getAllSocialDetailsRequest = createAction('GET_ALL_SOCIAL_DETAILS_REQUEST', data => data);
const getAllSocialDetailsSuccess = createAction('GET_ALL_SOCIAL_DETAILS_SUCCESS', data => data);
const getAllSocialDetailsError = createAction('GET_ALL_SOCIAL_DETAILS_ERROR');

// update social details action
const updateSocialDetailsRequest = createAction('UPDATE_SOCIAL_DETAILS_REQUEST', data => data);
const updateSocialDetailsSuccess = createAction('UPDATE_SOCIAL_DETAILS_SUCCESS', data => data);
const updateSocialDetailsError = createAction('UPDATE_SOCIAL_DETAILS_ERROR');

// clear existing social details action
const handleClearSocialDetails = createAction('HANDLE_CLEAR_SOCIAL_DETAILS', data => data);

/* ***WORK EXPERIENCE DETAILS**** */
// add Work Experience details action
const addWorkExperienceDetailsRequest = createAction('ADD_WORK_EXPERIENCE_DETAILS_REQUEST', data => data);
const addWorkExperienceDetailsSuccess = createAction('ADD_WORK_EXPERIENCE_DETAILS_SUCCESS', data => data);
const addWorkExperienceDetailsError = createAction('ADD_WORK_EXPERIENCE_DETAILS_ERROR');

// get Work Experience action
const getWorkExperienceDetailsRequest = createAction('GET_ALL_WORK_EXPERIENCE_DETAILS_REQUEST', data => data);
const getWorkExperienceDetailsSuccess = createAction('GET_ALL_WORK_EXPERIENCE_DETAILS_SUCCESS', data => data);
const getWorkExperienceDetailsError = createAction('GET_ALL_WORK_EXPERIENCE_DETAILS_ERROR');

// update Work Experience action
const updateWorkExperienceDetailsRequest = createAction('UPDATE_WORK_EXPERIENCE_DETAILS_REQUEST', data => data);
const updateWorkExperienceDetailsSuccess = createAction('UPDATE_WORK_EXPERIENCE_DETAILS_SUCCESS', data => data);
const updateWorkExperienceDetailsError = createAction('UPDATE_WORK_EXPERIENCE_DETAILS_ERROR');

// clear existing social details action
const handleClearWorkExperienceDetails = createAction('HANDLE_CLEAR_WORK_EXPERIENCE_DETAILS', data => data);

//****REFERENCE DETAILS*****
// add reference details action
const addReferenceDetailsRequest = createAction('ADD_REFERENCE_DETAILS_REQUEST', data => data);
const addReferenceDetailsSuccess = createAction('ADD_REFERENCE_DETAILS_SUCCESS', data => data);
const addReferenceDetailsError = createAction('ADD_REFERENCE_DETAILS_ERROR');

// get reference details action
const getAllReferenceDetailsRequest = createAction('GET_ALL_REFERENCE_DETAILS_REQUEST', data => data);
const getAllReferenceDetailsSuccess = createAction('GET_ALL_REFERENCE_DETAILS_SUCCESS', data => data);
const getAllReferenceDetailsError = createAction('GET_ALL_REFERENCE_DETAILS_ERROR');

// update reference details action
const updateReferenceDetailsRequest = createAction('UPDATE_REFERENCE_DETAILS_REQUEST', data => data);
const updateReferenceDetailsSuccess = createAction('UPDATE_REFERENCE_DETAILS_SUCCESS', data => data);
const updateReferenceDetailsError = createAction('UPDATE_REFERENCE_DETAILS_ERROR');

// clear existing reference details action
const handleClearReferenceDetails = createAction('HANDLE_CLEAR_REFERENCE_DETAILS', data => data);

//****UPLOAD DOCUMENTS DETAILS*****
// add document details action
const addDocumentDetailsRequest = createAction('ADD_DOCUMENT_DETAILS_REQUEST', data => data);
const addDocumentDetailsSuccess = createAction('ADD_DOCUMENT_DETAILS_SUCCESS', data => data);
const addDocumentDetailsError = createAction('ADD_DOCUMENT_DETAILS_ERROR');

// get document details action
const getAllDocumentDetailsRequest = createAction('GET_ALL_DOCUMENT_DETAILS_REQUEST', data => data);
const getAllDocumentDetailsSuccess = createAction('GET_ALL_DOCUMENT_DETAILS_SUCCESS', data => data);
const getAllDocumentDetailsError = createAction('GET_ALL_DOCUMENT_DETAILS_ERROR');

// update document details action
const updateDocumentDetailsRequest = createAction('UPDATE_DOCUMENT_DETAILS_REQUEST', data => data);
const updateDocumentDetailsSuccess = createAction('UPDATE_DOCUMENT_DETAILS_SUCCESS', data => data);
const updateDocumentDetailsError = createAction('UPDATE_DOCUMENT_DETAILS_ERROR');

// clear existing document details action
const handleClearDocumentDetails = createAction('HANDLE_CLEAR_DOCUMENT_DETAILS', data => data);
const handleClearOnboardingStore =createAction("HANDLE_CLEAR_ONBOARDING_STROE", data => data)


export default {
    //personal details
    addPersonalDetailsRequest,
    addPersonalDetailsSuccess,
    addPersonalDetailsError,

    getAllPersonalDetailsRequest,
    getAllPersonalDetailsSuccess,
    getAllPersonalDetailsError,

    updatePersonalDetailsRequest,
    updatePersonalDetailsSuccess,
    updatePersonalDetailsError,

    handleClearPersonalDetails,

    //family details
    addFamilyDetailsRequest,
    addFamilyDetailsSuccess,
    addFamilyDetailsError,

    getAllFamilyDetailsRequest,
    getAllFamilyDetailsSuccess,
    getAllFamilyDetailsError,

    updateFamilyDetailsRequest,
    updateFamilyDetailsSuccess,
    updateFamilyDetailsError,

    handleClearFamilyDetails,

    //Education details
    addEducationDetailsRequest,
    addEducationDetailsSuccess,
    addEducationDetailsError,

    getEducationDetailsRequest,
    getEducationDetailsSuccess,
    getEducationDetailsError,

    updateEducationDetailsRequest,
    updateEducationDetailsSuccess,
    updateEducationDetailsError,

    handleClearEducationDetails,

    //bank details
    addBankDetailsRequest,
    addBankDetailsSuccess,
    addBankDetailsError,

    getAllBankDetailsRequest,
    getAllBankDetailsSuccess,
    getAllBankDetailsError,

    updateBankDetailsRequest,
    updateBankDetailsSuccess,
    updateBankDetailsError,

    handleClearBankDetails,

    //social details
    addSocialDetailsRequest,
    addSocialDetailsSuccess,
    addSocialDetailsError,

    getAllSocialDetailsRequest,
    getAllSocialDetailsSuccess,
    getAllSocialDetailsError,

    updateSocialDetailsRequest,
    updateSocialDetailsSuccess,
    updateSocialDetailsError,

    handleClearSocialDetails,
    //Work Experience details
    addWorkExperienceDetailsRequest,
    addWorkExperienceDetailsSuccess,
    addWorkExperienceDetailsError,

    getWorkExperienceDetailsRequest,
    getWorkExperienceDetailsSuccess,
    getWorkExperienceDetailsError,

    updateWorkExperienceDetailsRequest,
    updateWorkExperienceDetailsSuccess,
    updateWorkExperienceDetailsError,

    handleClearWorkExperienceDetails,

    //reference details
    addReferenceDetailsRequest,
    addReferenceDetailsSuccess,
    addReferenceDetailsError,

    getAllReferenceDetailsRequest,
    getAllReferenceDetailsSuccess,
    getAllReferenceDetailsError,

    updateReferenceDetailsRequest,
    updateReferenceDetailsSuccess,
    updateReferenceDetailsError,

    handleClearReferenceDetails,


    //upload document details
    addDocumentDetailsRequest,
    addDocumentDetailsSuccess,
    addDocumentDetailsError,

    getAllDocumentDetailsRequest,
    getAllDocumentDetailsSuccess,
    getAllDocumentDetailsError,

    updateDocumentDetailsRequest,
    updateDocumentDetailsSuccess,
    updateDocumentDetailsError,

    handleClearDocumentDetails,

    getAllOnboardingDetailsRequest,
    getAllOnboardingDetailsSuccess,
    getAllOnboardingDetailsError,

    getAllEmpDocsRequest,
    getAllEmpDocsSuccess,
    getAllEmpDocsError,

    handleClearOnboardingStore,
}